import React, { useState, useEffect } from 'react';
import { Image, List, Popup } from 'antd-mobile';
import {PoweroffOutlined, SettingOutlined} from '@ant-design/icons';
import {getNavBarContainerStyle} from "../../../utils/deviceUtils";
import { useNavigate } from "react-router-dom";
import {UserMenuPath} from "../../../enums/DeliveryNavigatePathEnum";
import { getUserInfo, logout } from 'utils/auth';
import {RegisterAvatarIcon} from '../../../assets/icons';
import { t } from 'i18n';
import { getAppVersion } from '../../../utils/appRuntime';
import { formatLocalizedDate } from '../../../utils/dateFormatUtils';


interface DspUserMenuDrawerProps {
    visible: boolean;
    onClose: () => void;
}

const DspUserMenuDrawer: React.FC<DspUserMenuDrawerProps> = ({
    visible,
    onClose
}) => {
    const navigate = useNavigate();
    const [appVersion, setAppVersion] = useState<string>('V1.0');
    const userInfo = getUserInfo();

    // 获取应用版本号
    useEffect(() => {
        getAppVersion().then(version => {
            setAppVersion(version);
        }).catch(error => {
            console.error('Failed to get app version:', error);
            setAppVersion('V1.0');
        });
    }, []);

    // 当前日期格式化
    const formattedDate = formatLocalizedDate(new Date(), {
        month: 'long',
        day: '2-digit',
        year: 'numeric'
    });

    const userName = userInfo?.account.name;
    const userAvatar = userInfo?.account?.avatarUrl;

    return (
        <Popup
            position='left'
            visible={visible}
            onClose={onClose}
            closeOnMaskClick
        >
            <div {...getNavBarContainerStyle('p-4 h-full flex flex-col')}>
                {/* 用户信息区域 */}
                <div className="flex items-center mb-4">
                    <div
                        className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 text-xl overflow-hidden">
                        {userAvatar ? (
                            <Image
                                src={userAvatar}
                                width={64}
                                height={64}
                                fit='cover'
                                style={{ borderRadius: 32 }}
                            />
                        ) : (
                            <RegisterAvatarIcon className="w-12 h-12" />
                        )}
                    </div>
                    <div className="ml-3">
                        <div className="font-medium text-base">{userName}</div>
                        <div className="text-gray-500 text-sm">{formattedDate}</div>
                    </div>
                </div>

                {/* 菜单项 */}
                {
                    <List
                        className="flex-grow"
                        style={{
                            '--border-bottom': 'none',
                            '--border-top': 'none',
                        }}>
                        <List.Item prefix={<SettingOutlined />} onClick={() => { navigate(UserMenuPath.USER_MENU_SETTINGS) }}>
                            {t('pages.useMenu.settings')}
                        </List.Item>
                    </List>
                }

                {/* 底部区域 */}
                <div className="mt-auto w-full">
                    <List
                        style={{
                            '--border-top': 'none',
                        }}
                    >
                        <List.Item
                            prefix={<PoweroffOutlined />}
                            onClick={async () => { await logout('/login') }}
                        >
                            {t('pages.useMenu.signOut')}
                        </List.Item>
                    </List>
                    <div className="flex mt-2 p-2">
                        {t('pages.useMenu.privacyPolicy')}
                    </div>
                    <div className="flex p-2 text-gray-500">
                        {`V${appVersion}`}
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default DspUserMenuDrawer;